import {c as createCommonjsModule, g as getDefaultExportFromCjs} from "./_commonjsHelpers-8c19dec8.js";
import {i as interopRequireDefault} from "./interopRequireDefault-d2c9da36.js";
import {o as objectWithoutPropertiesLoose, _ as _extends_1} from "./defaultTheme-ca6a0b43.js";
import React from "react";
import {p as propTypes} from "./index-877ea290.js";
import {r as require$$3} from "./clsx.m-5dc7436b.js";
import {c as core} from "./index-0a000c27.js";
import {s as styled_1, u as useThemeProps_1} from "./useThemeProps-ef190a94.js";
import {L as ListContext_1} from "./ListContext-0f0f18c4.js";
import _jsxRuntime from "react/jsx-runtime";
var listItemIconClasses_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  exports.getListItemIconUtilityClass = getListItemIconUtilityClass;
  function getListItemIconUtilityClass(slot) {
    return (0, core.generateUtilityClass)("MuiListItemIcon", slot);
  }
  const listItemIconClasses = (0, core.generateUtilityClasses)("MuiListItemIcon", ["root", "alignItemsFlexStart"]);
  var _default = listItemIconClasses;
  exports.default = _default;
});
var ListItemIcon_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _objectWithoutPropertiesLoose2 = interopRequireDefault(objectWithoutPropertiesLoose);
  var _extends2 = interopRequireDefault(_extends_1);
  var React$1 = _interopRequireWildcard(React);
  var _propTypes = interopRequireDefault(propTypes);
  var _clsx = interopRequireDefault(require$$3);
  var _styled = interopRequireDefault(styled_1);
  var _useThemeProps = interopRequireDefault(useThemeProps_1);
  var _ListContext = interopRequireDefault(ListContext_1);
  const _excluded = ["className"];
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  const useUtilityClasses = (ownerState) => {
    const {
      alignItems,
      classes
    } = ownerState;
    const slots = {
      root: ["root", alignItems === "flex-start" && "alignItemsFlexStart"]
    };
    return (0, core.unstable_composeClasses)(slots, listItemIconClasses_1.getListItemIconUtilityClass, classes);
  };
  const ListItemIconRoot = (0, _styled.default)("div", {
    name: "MuiListItemIcon",
    slot: "Root",
    overridesResolver: (props, styles) => {
      const {
        ownerState
      } = props;
      return [styles.root, ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart];
    }
  })(({
    theme,
    ownerState
  }) => (0, _extends2.default)({
    minWidth: 56,
    color: theme.palette.action.active,
    flexShrink: 0,
    display: "inline-flex"
  }, ownerState.alignItems === "flex-start" && {
    marginTop: 8
  }));
  const ListItemIcon2 = /* @__PURE__ */ React$1.forwardRef(function ListItemIcon3(inProps, ref) {
    const props = (0, _useThemeProps.default)({
      props: inProps,
      name: "MuiListItemIcon"
    });
    const {
      className
    } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const context = React$1.useContext(_ListContext.default);
    const ownerState = (0, _extends2.default)({}, props, {
      alignItems: context.alignItems
    });
    const classes = useUtilityClasses(ownerState);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(ListItemIconRoot, (0, _extends2.default)({
      className: (0, _clsx.default)(classes.root, className),
      ownerState,
      ref
    }, other));
  });
  var _default = ListItemIcon2;
  exports.default = _default;
});
var ListItemIcon = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _exportNames = {
    listItemIconClasses: true
  };
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
      return _ListItemIcon.default;
    }
  });
  Object.defineProperty(exports, "listItemIconClasses", {
    enumerable: true,
    get: function() {
      return _listItemIconClasses.default;
    }
  });
  var _ListItemIcon = interopRequireDefault(ListItemIcon_1);
  var _listItemIconClasses = _interopRequireWildcard(listItemIconClasses_1);
  Object.keys(_listItemIconClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule")
      return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key))
      return;
    if (key in exports && exports[key] === _listItemIconClasses[key])
      return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function() {
        return _listItemIconClasses[key];
      }
    });
  });
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
});
var __pika_web_default_export_for_treeshaking__ = /* @__PURE__ */ getDefaultExportFromCjs(ListItemIcon);
export {ListItemIcon as L, __pika_web_default_export_for_treeshaking__ as _};
